<template lang="">
    <div>
        <b-row>
            <b-col cols="12">
                <b-card class="p-0 filter-card rounded-lg w-100">
                    <b-row>
                        <b-col cols="12">
                            <h3 class="ml-1 mb-2">Filters</h3>
                        </b-col>
                        <b-col md="4">
                            <!-- {{filter.course_id}}  -->
                            <v-select
                                v-model="filter.course_id"
                                :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
                                :options="courses"
                                class="w-100 mb-0"
                                :reduce="(val) => val.id"
                                placeholder="Course"
                                :label="$i18n.locale == 'en' ? 'name' : 'name_local'"
                            >
                                <template v-slot:option="option">
                                    {{ $i18n.locale == "ar" ? option.name_local : option.name }}
                                </template>
                                <template #selected-option="{ name, name_local }">
                                <div style="display: flex; align-items: baseline">
                                    <strong v-if="$i18n.locale == 'ar'">{{ name_local }} </strong>
                                    <strong v-else>{{ name }} </strong>
                                </div>
                                </template>
                                <template #no-options>
                                {{ $t("noMatching") }}
                                </template>
                            </v-select>
                        </b-col>
                        <b-col 
                            md="4" 
                            v-if="hasPermission('Trashed Materials')"
                        >
                            <v-select
                                v-model="filter.trashed"
                                :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
                                :options="trashOptions"
                                class="w-100 mb-0"
                                :reduce="(val) => val.id"
                                placeholder="Status"
                                :label="$i18n.locale == 'en' ? 'name' : 'name_local'"
                            >
                                <template v-slot:option="option">
                                {{ $i18n.locale == "ar" ? option.name_local : option.name }}
                                </template>
                                <template #selected-option="{ name, name_local }">
                                <div style="display: flex; align-items: baseline">
                                    <strong v-if="$i18n.locale == 'ar'">{{ name_local }} </strong>
                                    <strong v-else>{{ name }} </strong>
                                </div>
                                </template>
                                <template #no-options>
                                {{ $t("noMatching") }}
                                </template>
                            </v-select>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-card class="w-100 d-flex rounded-lg">
            <b-row>
                <b-col md="12" class="pb-2 w-100 d-flex justify-content-between">
                    <h3 class="ml-1 mb-2">Modules</h3>
                    <div>
                        <!-- <b-button
                            v-if="hasPermission('Trashed Materials')"
                            class="btn rounded-pill mr-2"
                            variant="primary"
                            @click="loadData()"
                        >
                            {{filter.trashed == 1 ? 'List' : 'Trashed'}}
                        </b-button> -->
                        <b-button
                            class="btn rounded-pill"
                            variant="primary"
                            @click="addModule()"
                        >
                            Create Module
                        </b-button>
                    </div>
                </b-col>
            </b-row>
            <center v-if="load">
                <b-spinner variant="primary" label="Spinning"></b-spinner>
            </center>
            <b-table 
                v-else
                :items="items.data" 
                :fields="fields" 
                striped 
                responsive
            >
            <template #cell(Course)="data">
                <div v-if="data.item.course !=null" > 
                    {{data.item.course.name}}
                </div>
                
            </template>
            <template #cell(description)="data">
                <div v-if="data.item.description !=null" > 
                    <span v-html="data.item.description"></span>
                </div>
            </template>
                <template #cell(Actions)="data">
                    <div class="d-flex justify-content-start align-items-center" v-if="filter.trashed == 1 || filter.trashed == null">
                        <b-link
                            :tooltip="'none'"
                            class="alert-link cutom-alert-link text-danger mr-1"
                            @click="restoreModule(data.item.id)"
                        >
                            <feather-icon :tooltip="'none'" icon="RotateCcwIcon" size="18" v-b-tooltip.hover.top="'restore'"/>
                        </b-link>
                        <b-link
                            :tooltip="'none'"
                            class="alert-link cutom-alert-link text-danger"
                            @click="hardDeleteModule(data.item.id)"
                        >
                            <feather-icon :tooltip="'none'" icon="Trash2Icon" size="18" v-b-tooltip.hover.top="'Delete'"/>
                        </b-link> 
                    </div>
                    <div class="d-flex justify-content-start align-items-center" v-else>
                        <b-link
                            class="alert-link cutom-alert-link"
                            :to="{ name: 'topics', query: { module_id: data.item.id} }"
                        >
                            <feather-icon icon="EyeIcon" size="18" v-b-tooltip.hover.top="'Show'"/>
                        </b-link>
                        <b-link
                            :tooltip="'none'"
                            class="alert-link cutom-alert-link mx-1"
                            :to="{ name: 'edit_module', params: { id: data.item.id} }"
                        >
                            <feather-icon :tooltip="'none'" icon="EditIcon" size="18" v-b-tooltip.hover.top="'Edit'"/>
                        </b-link>
                        <b-link
                            :tooltip="'none'"
                            class="alert-link cutom-alert-link text-danger"
                            @click="deleteModule(data.item.id)"
                        >
                            <feather-icon :tooltip="'none'" icon="Trash2Icon" size="18" v-b-tooltip.hover.top="'Delete'"/>
                        </b-link>
                    </div>
                </template>
            </b-table>
            <b-row>
                <b-col md="12" class="d-flex justify-content-center">
                    <b-pagination
                        v-model="items.current_page"
                        :total-rows="items.total"
                        :per-page="items.per_page"
                        @change="onPageChange"
                    ></b-pagination>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>
<script>
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { mapGetters } from "vuex";
import vSelect from "vue-select";
import {
  BTable,
  BButton,
  BFormCheckbox,
  BCard,
  BRow,
  BCol,
  BBadge,
  BCardText,
  BAvatar,
  VBTooltip,
  BSpinner,
  BPagination,
  BLink,
} from "bootstrap-vue";
export default {
    name:'modules',
    components: {
        BTable,
        BButton,
        BFormCheckbox,
        BCard,
        BRow,
        BCol,
        BBadge,
        BAvatar,
        BCardText,
        BLink,
        ToastificationContent,
        vSelect,
        BSpinner,
        BPagination,
    },
    directives: {
        Ripple,
        'b-tooltip': VBTooltip,
    },
    watch: {
        "filter.course_id"(newVal) {
            this.$router.push({name:'modules', query: { course_id: this.filter.course_id}})
            this.$store.dispatch("modules/list",  this.filter);
        },
        "filter.trashed"(newVal) {
            this.$store.dispatch("modules/list", this.filter );
        },
    },
    computed: {
        ...mapGetters({
            items: "modules/items",
            load: "modules/load",
            courses: "courses/lookups",
        }),
        id() {
            return this.$route.query.course_id
                ? this.$route.query.course_id 
                : null;
        },
    },
    data() {
        return {
            filter: {
                course_id: null,
                trashed: 0,
            },
            trashOptions:[
                {id: 0 , name: 'Active'},
                {id: 1 , name: 'Inactive'},
            ],
            fields: [
                { key: "name", label: "Name", sortable: true },
                { key: "description", label: "Description" },
                "Course",
                "Actions",
            ],
        }
    },
    methods:{
        loadData(){
            this.filter.trashed = !this.filter.trashed;
            this.init()
        },
        init() {
            this.$store.dispatch("courses/lookups").then(_=>{
                this.filter.course_id = this.id ? this.id : null
                this.$store.dispatch("modules/list",{ ...this.filter })
            }).finally(_=>{
                setTimeout(() => {
                    // this.filter.course_id = this.courses.find(course => course.id == this.filter.course_id);
                    // console.log('--------------this.filter.course_id',this.filter.course_id);
                                
                    // this.checkCourx = true;
                }, 1000);
            })
        },
        onPageChange(page) {
            this.$store
                .dispatch("modules/list", { ...this.filter, page:page })
        },
        addModule(){
            this.$router.push({name:'add_module', query: {course_id: this.id}})
        },
        refreshData(){
            this.$store
                .dispatch("modules/list", { ...this.filter, page:this.items.current_page })
        },
        deleteModule(id){
            this.$swal({
                title: 'Are you sure?',
                text: "You want to delete!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, cancel it!',
                confirmButtonColor: '#E84185',
            }).then(result => {
                if (result.value) {
                    this.$store.dispatch("modules/remove", id).then(_=>{
                        this.refreshData();
                        this.$swal({
                            icon: 'success',
                            title: 'Deleted!',
                            confirmButtonColor: '#E84185',
                        })
                    }).catch(error => {
                        
                        
                        if (error.response) {
                        this.$swal({
                            icon: 'error',
                            title: `<h4>${error.response.data.error}</h4>`,
                            showConfirmButton: true,
                            confirmButtonColor: '#E84185',
                            allowOutsideClick: true
                        });
                        }
                    });
                }
            })
        },
        hardDeleteModule(id){
            this.$swal({
                title: 'Are you sure?',
                text: "You want to hard delete!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, cancel it!',
                confirmButtonColor: '#E84185',
            }).then(result => {
                if (result.value) {
                    this.$store.dispatch("modules/hardRemove", id).then(_=>{
                        this.init(); 
                        this.$swal({
                            icon: 'success',
                            title: 'Deleted!',
                            confirmButtonColor: '#E84185',
                        })
                    }).catch(error => {
                        if (error.response) {
                        this.$swal({
                            icon: 'error',
                            title: `<h4>${error.response.data.error}</h4>`,
                            showConfirmButton: true,
                            confirmButtonColor: '#E84185',
                            allowOutsideClick: true
                        });
                        }
                    });
                }
            })
        },
        restoreModule(id){
            this.$swal({
                title: 'Are you sure?',
                text: "You want to restore!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, restore it!',
                cancelButtonText: 'No, cancel it!',
                confirmButtonColor: '#E84185',
            }).then(result => {
                if (result.value) {
                    this.$store.dispatch("modules/restore", id).then(_=>{
                        this.init(); 
                        this.$swal({
                            icon: 'success',
                            title: 'Restored!',
                            confirmButtonColor: '#E84185',
                        })
                    }).catch(error => {
                        if (error.response) {
                        this.$swal({
                            icon: 'error',
                            title: `<h4>${error.response.data.error}</h4>`,
                            showConfirmButton: true,
                            confirmButtonColor: '#E84185',
                            allowOutsideClick: true
                        });
                        }
                    });
                }
            })
        }
    },
    mounted() {
        this.init();
    },
}
</script>
<style lang="scss">
    
</style>